import _extends from "@babel/runtime/helpers/extends";
import Dropdown from '../Dropdown/Dropdown';
import React from 'react';
import ComposedField from './ComposedField';
/**
 * Renders a select field composed with validation and tooltip labels.
 * For maximum compatibility with typical fields this field expects to receive
 * the option value as the value and will return the option value as the first
 * parameter in the onChange rather than that the entire option object.
 */
export default function ComposedSelectField(_ref) {
  let {
    disableBorder,
    disableDeselect,
    options,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(ComposedField, props, _ref2 => {
    let {
      doValidation,
      onChange,
      onBlur,
      internalLabel,
      id,
      ...composedProps
    } = _ref2;
    return /*#__PURE__*/React.createElement(Dropdown, _extends({}, composedProps, {
      disableBorder: disableBorder,
      disableDeselect: disableDeselect,
      showRequiredInPlaceholder: internalLabel,
      id: id,
      isDisabled: composedProps.disabled,
      isRequired: composedProps.required,
      maxMenuHeight: props.maxMenuHeight,
      options: options,
      value: composedProps.value,
      visited: composedProps.visited,
      onChange: value => doValidation(value).then(() => onChange && onChange(value)),
      onBlur: e => doValidation(composedProps.value).then(() => onBlur && onBlur(e))
    }));
  });
}